import React, { useState } from 'react'
import { Swords, Gift, Zap } from 'lucide-react'
import { VersusHeader } from './VersusHeader.jsx'
import { profilePhoto } from './Avatar.jsx'

export function SynapseDuelCard({ onLaunchDuel, session }) {
  const [searching, setSearching] = useState(false)

  const me = {
    name: session?.name || session?.email?.split('@')[0] || 'Tú',
    src: session?.picture || profilePhoto(session?.name || 'viajero'),
  }

  const handleLaunch = () => {
    setSearching(true)
    setTimeout(() => {
      setSearching(false)
      onLaunchDuel?.()
    }, 1000)
  }

  return (
    <div className="relative rounded-2xl bg-gradient-to-b from-[#18132b] via-[#120f20] to-[#0d0a17] border border-purple-800/40 p-4 shadow-xl overflow-hidden">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-32 bg-purple-600/10 rounded-full blur-3xl pointer-events-none" />

      {/* Header */}
      <div className="flex items-center justify-between gap-2 mb-2">
        <div className="flex items-center gap-1.5 text-purple-300 text-xs font-bold uppercase tracking-wider">
          <Swords size={14} className="text-purple-400" />
          <span>DUELO RELÁMPAGO 1V1</span>
        </div>
        <div className="flex items-center gap-1 px-2 py-0.5 rounded-full bg-cyan-950/70 border border-cyan-500/40 text-cyan-300 text-[10px] font-bold">
          <Gift size={11} className="text-cyan-400" />
          <span>Cofre Cósmico</span>
        </div>
      </div>

      <h3 className="text-base font-black text-white">Batalla de Sinapsis</h3>
      <p className="text-xs text-slate-400 mt-0.5 leading-snug">
        Encuentra oponente aleatorio en 3s. Resuelve 5 acertijos lógicos antes que tu rival.
      </p>

      {/* Matchup Arena — literal face-off */}
      <div className="relative my-3 rounded-2xl bg-slate-900/80 border border-slate-800 overflow-hidden">
        <div className="absolute inset-x-0 bottom-0 h-12 bg-gradient-to-t from-purple-900/25 to-transparent pointer-events-none" />
        <div className="relative px-2 pt-3 pb-2">
          <VersusHeader
            variant="duelists"
            size={106}
            me={{ ...me, sub: 'Nivel 7 · 840 BP' }}
            foe={{
              name: 'Rival Online',
              src: profilePhoto('sinapsis'),
              sub: searching ? 'Conectando…' : 'Buscando…',
            }}
          />
        </div>
        <div className="relative flex items-center justify-center gap-1 pb-2 text-[9px] text-emerald-400 font-medium">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-400" />
          <span>Ping 24ms</span>
        </div>
      </div>

      {/* Launch Battle CTA Button */}
      <button
        type="button"
        onClick={handleLaunch}
        className="w-full py-3 rounded-xl bg-gradient-to-r from-purple-600 via-indigo-600 to-purple-500 hover:from-purple-500 hover:to-indigo-500 text-white font-extrabold text-sm flex items-center justify-center gap-2 shadow-lg shadow-purple-600/30 active:scale-[0.98] transition-all cursor-pointer"
      >
        <Zap size={16} className="text-yellow-300 fill-yellow-300" />
        <span>{searching ? '¡CONECTANDO OPONENTE...!' : '¡LANZAR BATALLA (60s)! →'}</span>
      </button>
    </div>
  )
}
